import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bitbucket = defineConnector({
  identifier: "bitbucket",
  name: "Bitbucket",
  tagLine: "Git code management and CI/CD",
  keywords:
    "atlassian git repositories pull requests pipelines ci cd source control",
  logo,
  protocol: "http",
  tags: ["engineering"],
  // bitbucket.org itself is included so the connector can back git sync: app
  // passwords authenticate git-over-HTTPS on the same host.
  defaultUrlPattern: () =>
    "^(?:https://api\\.bitbucket\\.org/.*)|^(?:https://bitbucket\\.org/.*)",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.appPassword,
    }),
  steps: [
    {
      title: "Create an app password",
      items: [
        {
          kind: "markdown",
          content:
            "In Bitbucket, go to **Personal settings > App passwords** and create a new app password with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your Bitbucket credentials",
      items: [
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
          helperText: "Your Bitbucket username (not email).",
        },
        {
          kind: "input",
          label: "App password",
          required: true,
          target: { kind: "secrets", field: "appPassword" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.bitbucket.org/2.0/user",
  },
});
